<div  *ngIf="!dropdown">
      <div class="select-wrapper" [ngClass]="buttonClass">
        <select
         tabNext
         #mySelect class="w-100 p-l-15 text-truncate p-r-25"
         [disabled]="disabled"
         [(ngModel)]="selectValue"
          (ngModelChange)="selectValueChange($event)">
          <option value=""></option>
          <option *ngFor="let item of data" [value]="item.id "> {{ item?.name }} </option>
        </select>
      </div>
  </div>
  
  <div *ngIf="dropdown" class="d-flex gap-3"  [ngClass]="buttonClass">
    <label class="text-gray text-nowrap secondary-text mb-0 d-flex align-items-center" [for]="id">
      {{label}}
    </label>
    <select tabNext #mySelect class="form-select form-select_Wrapper text-truncate" 
      [disabled]="disabled" 
      [id]="id"
      [(ngModel)]="selectValue"
      (ngModelChange)="selectValueChange($event)">
      <option value=""></option>
      <option *ngFor="let item of data" [value]="item.id "> {{ item?.name }} </option>
    </select>
    
    </div>
  